// Import 3rd-party dependencies
import { AbstractControl, ValidationErrors } from '@angular/forms';

// Import project-specific dependencies
import { URL_VALIDATOR_CONSTS } from '@app/config/constants';

export const urlValidator = (control: AbstractControl): ValidationErrors | null => {
  const value = (control.value as string) || '';
  const valid = URL_VALIDATOR_CONSTS.URL_REGEX.test(value.trim());
  return !valid ? { invalidUrl: { value: control.value as string } } : null;
};
